// extracted by mini-css-extract-plugin
export default {"container":"BillingResult_container__ZHfgY"};